__turbopack_context__.v({
  "articleBottomDescription": "ArticleBottomDescription-module-scss-module__pu6MFG__articleBottomDescription",
  "descriptionTitle": "ArticleBottomDescription-module-scss-module__pu6MFG__descriptionTitle",
  "hideButton": "ArticleBottomDescription-module-scss-module__pu6MFG__hideButton",
  "text": "ArticleBottomDescription-module-scss-module__pu6MFG__text",
  "text_closed": "ArticleBottomDescription-module-scss-module__pu6MFG__text_closed",
});
